import { cn, focusRing } from '@/lib/utils';

/* Keyboard-only "skip to content" affordance.
 * Hidden until focused, jumps focus past the header to #main-content.
 */
export function SkipLink() {
  return (
    <a
      href="#main-content"
      className={cn(
        'sr-only focus:not-sr-only',
        'focus:fixed focus:left-4 focus:top-4 focus:z-50',
        'focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground',
        focusRing,
      )}
    >
      Skip to main content
    </a>
  );
}
